import { Injectable } from '@angular/core';
import { HttpErrorResponse, HttpHandler, HttpInterceptor, HttpRequest, HttpEvent } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { captureMessage } from '@sentry/angular';

@Injectable({ providedIn: 'root' })
export class HttpSentryInterceptorService implements HttpInterceptor {
  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(request).pipe(
      catchError((error: HttpErrorResponse) => {
        this.processSentryReporting(error, request);
        return throwError(error);
      }),
    );
  }

  private processSentryReporting(error: HttpErrorResponse, request: HttpRequest<any>): void {
    const isServerError = error.status >= 500;

    if (isServerError) {
      this.captureSentryMessage(error, request);
    }
  }

  private captureSentryMessage(error: HttpErrorResponse, request: HttpRequest<any>): void {
    const eventMessage = `API Error ${error.status}: ${request.urlWithParams}`;

    captureMessage(eventMessage, {
      level: 'error',
      extra: {
        status: error.status,
        statusText: error.statusText,
        url: error.url,
        method: request.method,
        requestBody: request.body,
        responseBody: error.error,
      },
    });
  }
}
